import { connect } from 'react-redux';
import { compose } from 'redux';
import { Utils } from 'manifesto.js';
import { withPlugins } from '../extend/withPlugins';
import { getLogoutService, getTokenService } from '../lib/getServices';
import * as actions from '../state/actions';
import {
  getAuth,
  getAuthProfiles,
  selectCurrentAuthServices,
  getAccessTokens,
} from '../state/selectors';
import { IIIFAuthentication } from '../components/IIIFAuthentication';

/**
 * mapStateToProps - to hook up connect
 * @memberof FullScreenButton
 * @private
 */
const mapStateToProps = (state, { windowId }) => {
  const services = selectCurrentAuthServices(state, { windowId });

  const authProfiles = getAuthProfiles(state);

  // TODO: get the most actionable auth service...
  const service = services[0];
  if (!service) return {};
  /** get the auth service profile */
  const serviceProfile = (s) => authProfiles.find(p => p.profile === s.getProfile());
  const authServiceExternal = (serviceProfile(service)?.external);
  /** get the key to track an auth service by */
  const serviceKey = (authServiceExternal) ? (service.id || 'external') : (service.id);

  const accessTokenService = getTokenService(service);
  const logoutService = getLogoutService(service);

  const authStatuses = getAuth(state);
  const authStatus = service && authStatuses[serviceKey];
  const accessTokens = getAccessTokens(state);
  const accessTokenStatus = accessTokenService && accessTokens[accessTokenService.id];

  let status = null;

  if (!authStatus) {
    status = null;
  } else if (authStatus.isFetching) {
    if (authStatus.windowId === windowId) status = 'cookie';
  } else if (accessTokenStatus && accessTokenStatus.isFetching) {
    if (authStatus.windowId === windowId) status = 'token';
  } else if (authStatus.ok) {
    status = 'ok';
  } else if (authStatus.ok === false) {
    status = 'failed';
  }

  const profile = service.getProfile();

  const isInteractive = authProfiles.some(
    config => (config.profile === profile) && !(config.external || config.kiosk),
  );

  return {
    accessTokenServiceId: accessTokenService && accessTokenService.id,
    authServiceExternal,
    authServiceId: serviceKey,
    confirm: service && service.getConfirmLabel(),
    description: service && service.getDescription(),
    failureDescription: service && service.getFailureDescription(),
    failureHeader: service && service.getFailureHeader(),
    header: service && service.getHeader(),
    isInteractive,
    label: service && service.getLabel()[0].value,
    logoutConfirm: logoutService
      && logoutService.getLabel()[0]
      && logoutService.getLabel()[0].value,
    logoutServiceId: logoutService && logoutService.id,
    profile,
    status,
  };
};

/**
 * mapDispatchToProps - used to hook up connect to action creators
 * @memberof ManifestListItem
 * @private
 */
const mapDispatchToProps = {
  handleAuthInteraction: actions.addAuthenticationRequest,
  resetAuthenticationState: actions.resetAuthenticationState,
  resolveAccessTokenRequest: actions.resolveAccessTokenRequest,
  resolveAuthenticationRequest: actions.resolveAuthenticationRequest,
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withPlugins('IIIFAuthentication'),
);

export default enhance(IIIFAuthentication);
